module.exports = __webpack_public_path__ + "static/media/p2008audio.6eb9d963.jpg";